<footer class="ps-4">&copy; 2026 {{COMPANY_SITE}}</footer>